<template>
    <div>
        <label for="section" class="sr-only">Jump to Section</label>
        <select
            id="section"
            name="section"
            v-model="selected"
            class="form-select"
            @change="handleSelect"
        >
            <option value="">Jump to Section</option>
            <option v-for="option in mailGroups">{{ option.name }}</option>
        </select>
    </div>
</template>

<script>
import { ref } from 'vue';
export default {
    components: {},
    setup() {
        const selected = ref(null);
        const mailGroups = [
            {
                name: 'Account and Credit Monitoring',
                value: 'Account and Credit Monitoring',
            },
            {
                name: 'Alerts and Availability',
                value: 'Alerts and Availability',
            },
            {
                name: 'Companion Pass Notifications',
                value: 'Companion Pass Notifications',
            },
            { name: 'Missing Card Requests', value: 'Missing Card Requests' },
            {
                name: 'Promos and Special Offers',
                value: 'Promos and Special Offers',
            },
            { name: 'System Updates', value: 'System Updates' },
            {
                name: 'User Account Notifications',
                value: 'User Account Notifications',
            },
            {
                name: 'User Invitation Management',
                value: 'User Invitation Management',
            },
        ];
        const handleSelect = () => {
            var section = document.getElementById(`group-${selected.value}`);
            console.log(section);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        };
        return { handleSelect, mailGroups, selected };
    },
};
</script>
